<template>
  <div class="home">
      <div class="list" :loading="tableLoading">
          <List>
            <ListItem v-for="(item,i) in tableData.data" :key='i'>
              <div class="listdiv">
                <div class="div" @click="$router.push('teacherList/details?id='+item.id)"><img style="height:6vh" :src="path+item.avatar" alt="">
                <div>
                  <p>{{item.real_name}}</p>
                  <p>{{item.curse_title}}</p>
                </div>
                </div>
              </div>
            </ListItem>
          </List>
      </div>
     <Page
      style="text-align:right"
      :total="tableData.total"
      :current="tableData.current_page"
      show-total
      @on-change="getData"
    />
    <!-- <Modal v-model="detailShow" @on-cancel="detailShow=false" title="内容">
      <Row style="line-height:3;max-height:600px;overflow:auto">
        <Col span='24'>姓名：{{details.real_name}}</Col>
        <Col span='24'><img style="width:300px" :src="path+details.avatar" alt=""></Col>
        <Col span='24' v-html="details.instro"></Col>
      </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="detailShow=false">关闭</Button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import indexPage from "../../mixins/indexPage";
export default {
  components: {},
  mixins: [indexPage],
  data() {
    return {
      searchData:{
        pageSize:20,
        is_recommend:2
      },
      details:{},
      detailShow:false,
      indexUrl: "/app/teacher/index",
    };
  },
  activated() {},
  methods: {
    detailc(row){
      this.detailShow=true
      this.details=row
    }
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 90%;
  margin:0 auto 10px;
  min-height: 50vh;
  .ivu-card{
    border-radius: 10px;
    margin: 10px 0;
  }
  .list {
    width: 100%;
    margin-bottom: 20px;
    /deep/.ivu-list-items {
      margin: 10px;
     
    }
    
    .div{
      display: flex;
      align-items: center;
      div{
        margin-left:1vw;
      }
    }
    .ivu-list-item {
      cursor: pointer;
      display: inline-block;
      width: 25%;
      span {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        background: rgb(255, 196, 2);
        margin-right: 5px;
      }
    } 
  }
}
</style>
